/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
    isEqual as _isEqual,
    cloneDeep as _cloneDeep,
    get as _get,
} from "lodash";

import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormHelperText from "@mui/material/FormHelperText";

import Auth from "../../../../data/auth-service";
import FilterService from "../../../../data/filter-service";
import TargetService from "../../../../data/target-service";
import SystemService from "../../../../data/system-service";
import DataContext from "../../../../data/data-context";
import SessionService from "../../../../data/session-service";
import SensorsService from "../../../../data/sensors-service";
import useInterval from "../../../../libraries/useinterval";

import Validator, {
    useValidate,
    checkValidity,
} from "../../../../components/validator";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
    },
    button: {
        marginRight: theme.spacing(1),
    },
}));

const CreateSession = () => {
    const classes = useStyles();
    const [hasChanges, setHasChanges] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const routeParams = useParams();
    const sessionForm = useValidate({});
    const navigate = useNavigate();
    const [filterList, setFilterList] = useState([]);
    const [targetList, setTargetList] = useState([]);
    const [sourceList, setSourceList] = useState([]);
    const [valid, setValid] = useState(false);
    const { systemSettings } = useContext(DataContext);
    const [buttonState, setButtonState] = useState(false);
    const [updateSession, setUpdateSession] = useState({});
    const [sessionService, setSessionService] = useState();
    const [filterService, setFilterService] = useState();
    const [targetService, setTargetService] = useState();
    const [validPacket, setValidPacket] = useState(true);
    const [validVNI, setValidVNI] = useState(true);
    const [validNumber, setValidNumber] = useState(true);
    const [instance, setInstance] = useState();
    const [updateSensor, setUpdateSensor] = useState(null);
    const [sensors, setSensors] = useState([]);
    const [Uuid, setUuid] = useState("");
    const [isSensor, setIsSensor] = useState(false);
    const [applianceFilter] = useState({
        sensor: true,
        btsensor: false,
    });
    const [filter] = useState({
        q: "",
        limit: 1000,
        name: "",
        host: "",
        model: "",
        status: {
            critical: true,
            warning: true,
            normal: true,
        },
        policies: [],
        sort: "status+desc",
    });
    const [sessiondata, setSessionData] = useState({
        TrafficMirrorSessionId: "",
        TrafficMirrorTargetId: "",
        TrafficMirrorFilterId: "",
        NetworkInterfaceId: "",
        OwnerId: "",
        PacketLength: null,
        SessionNumber: null,
        VirtualNetworkId: null,
        Description: "",
        Tags: [
            {
                Key: "",
                Value: "",
            },
        ],
    });
    const awsPerms = Auth.permissions.get("AWS");
    const [readonly] = useState(!awsPerms.write);

    const getSensors = (search, applianceFilter) => {
        SensorsService.getData(search).then((res) => {
            if (!res) res = [];
            setSensors(applyApplianceFilter(res, applianceFilter));
        });
    };

    const applyApplianceFilter = (res, appFil) => {
        const s = res.filter((v) => {
            const bt = _get(v, "data.backtesting", "");
            if (appFil.sensor && !bt) {
                return v;
            } else if (appFil.btsensor && bt) {
                return v;
            } else if (!appFil.sensor && !appFil.btsensor) {
                return v;
            }
            return null;
        });

        return s;
    };

    const buildFilter = useCallback(() => {
        const f = Object.keys(filter).reduce((a, c) => {
            switch (c) {
                case "status":
                    a = Array.prototype.concat(
                        a,
                        Object.keys(filter[c]).map((v) => {
                            if (filter[c][v]) return "status=" + encodeURIComponent(v);
                            return null;
                        })
                    );
                    break;
                case "sort":
                    a.push("sort=" + filter[c]);
                    break;
                case "policies":
                    a = Array.prototype.concat(
                        a,
                        filter[c].map((v) => {
                            return "filter=" + encodeURIComponent(`${v.type}=${v.name}`);
                        })
                    );
                    break;
                case "q":
                    if (filter[c])
                        a.push("q=" + encodeURIComponent(filter[c].toLowerCase()));
                    break;
                case "limit":
                    if (filter[c]) a.push("limit=" + filter[c]);
                    break;
                default:
                    if (filter[c])
                        a.push("filter=" + encodeURIComponent(`${c}=${filter[c]}`));
            }

            return a;
        }, []);

        return f.join("&");
    }, [filter]);

    useEffect(() => {
        getSensors(buildFilter(), applianceFilter);
    }, []);

    useEffect(() => {
        getSensors(buildFilter(), applianceFilter);
    }, [applianceFilter]);

    useInterval(() => {
        getSensors(buildFilter(), applianceFilter);
    }, 15000);

    useEffect(() => {
        if (systemSettings && systemSettings.aws) {
            if (!readonly) {
                SystemService.awsCredAccess().then((res) => {
                    if (res) {
                        const region = systemSettings.aws.as_conf.region;
                        const accessKeyId = systemSettings.aws.user_creds.access_key_id;
                        const secretAccessKey = res.AWSSK;
                        initializeService(region, accessKeyId, secretAccessKey);
                    }
                });
            }
        }
    }, [systemSettings]);

    const initializeService = async (awsregion, accessKeyId, secretAccessKey) => {
        const config = {
            region: awsregion,
            credentials: {
                accessKeyId,
                secretAccessKey,
            },
        };
        const sessionservice = new SessionService(config);
        const filterservice = new FilterService(config);
        const targetservice = new TargetService(config);
        setSessionService(sessionservice);
        setFilterService(filterservice);
        setTargetService(targetservice);
    };

    useEffect(() => {
        setValid(
            (sessiondata.Description || "").length > 0 &&
            (sessiondata.NetworkInterfaceId || "").length > 0 &&
            (sessiondata.TrafficMirrorFilterId || "").length > 0 &&
            (sessiondata.TrafficMirrorTargetId || "").length > 0 &&
            sessiondata.SessionNumber !== null
        );
        setHasChanges(!_isEqual(sessiondata, updateSession));
    }, [sessionForm, sessiondata, updateSession, valid]);

    const getFilters = async () => {
        const res = await filterService.getFilters();
        if (Object.prototype.toString.call(res).includes("Array")) {
            const filterOptions = res.map((filter) => ({
                value: filter.TrafficMirrorFilterId,
                label: filter.Description,
            }));
            setFilterList(filterOptions);
        }
    };

    const getTargets = async () => {
        const res = await targetService.getTargets();
        if (Object.prototype.toString.call(res).includes("Array")) {
            const targetOptions = res.map((target) => ({
                value: target.TrafficMirrorTargetId,
                label: target.Description,
            }));
            setTargetList(targetOptions);
        }
    };

    const getSources = async () => {
        const type = "network-interface";
        const res = await targetService.getNetworkInterfaces(type);

        if (Object.prototype.toString.call(res).includes("Array")) {
            const sourceOptions = res.map((source) => ({
                value: source.NetworkInterfaceId,
                label: source.Description,
            }));
            setSourceList(sourceOptions);
        }
    };

    useEffect(() => {
        if (filterService) {
            getFilters();
        }
    }, [filterService]);

    useEffect(() => {
        if (targetService) {
            getTargets();
        }
    }, [targetService]);

    useEffect(() => {
        if (targetService) {
            getSources();
        }
    }, [targetService]);

    const getSessionId = async (TrafficMirrorSessionId) => {
        try {
            if (
                !sessionService ||
                typeof sessionService.getSessionById !== "function"
            ) {
                throw new Error(
                    "Session service is not properly initialized or getSessionById method is not available"
                );
            }
            const res = await sessionService.getSessionById(TrafficMirrorSessionId);
            if (res) {
                return res;
            } else {
                throw new Error("Session not found");
            }
        } catch (error) {
            console.error("Error fetching session by Id:", error);
            toast.error(`Failed to fetch session by Id: ${error.message}`);
            return null;
        }
    };

    useEffect(() => {
        const fetchSession = async () => {
            if (routeParams.TrafficMirrorSessionId && sessionService) {
                try {
                    const res = await getSessionId(routeParams.TrafficMirrorSessionId);
                    if (res) {
                        setIsUpdate(true);
                        setSessionData(res[0]);
                        setUpdateSession(res[0]);
                    }
                } catch (error) {
                    console.error("Error fetching session:", error);
                }
            }
        };

        fetchSession();
    }, [sessionService]);

    useEffect(() => {
        const getTargetDetails = async () => {
            if (sessiondata.TrafficMirrorTargetId && targetService) {
                try {
                    const res = await targetService.getTargetById(
                        sessiondata.TrafficMirrorTargetId
                    );
                    const data = {
                        "traffic-mirror-target-id": sessiondata.TrafficMirrorTargetId,
                    };
                    const TargetVNI = await sessionService.getSessions(data);
                    if (
                        TargetVNI.length > 0 &&
                        TargetVNI[TargetVNI.length - 1].VirtualNetworkId
                    ) {
                        setSessionData((prevSessionData) => ({
                            ...prevSessionData,
                            VirtualNetworkId:
                                TargetVNI[TargetVNI.length - 1].VirtualNetworkId,
                        }));
                    }
                    const targetDetails = res[0].NetworkInterfaceId;
                    const instanceDetails = await targetService.getInstances(
                        targetDetails
                    );
                    setInstance(instanceDetails.Reservations[0].Instances[0]);
                } catch (error) {
                    console.error("Error fetching instance details:", error);
                }
            }
        };
        getTargetDetails();
    }, [sessiondata.TrafficMirrorTargetId, targetService]);

    const handleUpdateVNI = (vni, mtu) => {
        const updatedSensorData = {
            data: {
                ..._cloneDeep(updateSensor.data),
            },
            update_vxlan: true,
        };
        updatedSensorData.data.vxlan_id = vni;
        updatedSensorData.data.vxlan_dstport = 4789;
        updatedSensorData.data.vxlan_mtu = mtu;
        SensorsService.updateSensor(Uuid, updatedSensorData);
    };

    useEffect(() => {
        if (instance) {
            const uuids = sensors
                .map((v) => {
                    if (v.host === instance.PrivateIpAddress) {
                        setIsSensor(true);
                        return v.uuid;
                    }
                    return null;
                })
                .filter((uuid) => uuid !== null);
            const uuid = uuids.length > 0 ? uuids[0] : null;
            if (uuid) {
                setUuid(uuid);
                SensorsService.getSensor(uuid).then((res) => {
                    setUpdateSensor(res);
                });
            }
        }
    }, [instance]);

    const handleAutocompletechange = (event, newValue, field) => {
        sessionForm.set({ ...sessionForm.get(), [field]: newValue });
        setSessionData((prevData) => ({
            ...prevData,
            [field]: newValue,
        }));
    };

    const handleClose = () => {
        navigate("/system/port_mirroring/aws", { state: { tab: 3 } });
    };

    const handleSessionChange = (e, validID, valid) => {
        sessionForm.set({ ...sessionForm.get(), [validID]: valid });
        const s = { ...sessiondata };
        s[e.target.name] =
            e.target.type === "number" ? parseInt(e.target.value) : e.target.value;
        setSessionData(s);
    };

    const handleVNI = (e) => {
        const newValue = e.target.value.trim();
        const isValid =
            newValue === "" ||
            (parseInt(newValue) > 0 && parseInt(newValue) <= 16777215);
        setValidVNI(isValid);
        setSessionData({
            ...sessiondata,
            VirtualNetworkId: newValue === "" ? "" : parseInt(newValue),
        });
    };

    const handleSessionNumber = (e) => {
        const newValue = e.target.value.trim();
        const isValid =
            newValue !== "" && parseInt(newValue) > 0 && parseInt(newValue) <= 32766;
        setValidNumber(isValid);
        setSessionData({
            ...sessiondata,
            SessionNumber: newValue === "" ? "" : parseInt(newValue),
        });
    };

    const handlePacketlength = (e) => {
        const newValue = e.target.value.trim();
        const isValid =
            newValue === "" || (parseInt(newValue) > 0 && parseInt(newValue) <= 1540);
        setValidPacket(isValid);
        setSessionData({
            ...sessiondata,
            PacketLength: newValue === "" ? "" : parseInt(newValue),
        });
    };

    const handleSubmit = async () => {
        if (isSensor) {
            if (isUpdate) {
                try {
                    const res = await sessionService.modifySession(sessiondata);
                    if (res.$metadata.httpStatusCode === 200) {
                        const vni = res.TrafficMirrorSession.VirtualNetworkId;
                        const mtu = res.TrafficMirrorSession.PacketLength;
                        handleUpdateVNI(vni, mtu);
                        handleClose();
                        SystemService.addAuditRecord({ "source": "AWS config", "subject": sessiondata.Description, "action": "update mirror session", "result": true });
                        toast.success("Session updated successfully");
                    } else {
                        throw new Error(res);
                    }
                } catch (error) {
                    console.error("Error:", error);
                    SystemService.addAuditRecord({ "source": "AWS config", "subject": sessiondata.Description, "action": "Error: " + error, "result": false });
                    toast.error(`Failed to update session.Please try again. \n${error}`);
                }
            } else {
                try {
                    const res = await sessionService.createSession(sessiondata);
                    if (res.$metadata.httpStatusCode === 200) {
                        const vni = res.TrafficMirrorSession.VirtualNetworkId;
                        const mtu = res.TrafficMirrorSession.PacketLength;
                        handleUpdateVNI(vni, mtu);
                        handleClose();
                        SystemService.addAuditRecord({ "source": "AWS config", "subject": sessiondata.Description, "action": "create mirror session", "result": true });
                        toast.success("Session created successfully");
                    } else {
                        throw new Error(res);
                    }
                } catch (error) {
                    console.error("Error:", error);
                    SystemService.addAuditRecord({ "source": "AWS config", "subject": "AWS Mirror Session", "action": "Error: " + error, "result": false });
                    toast.error(`Failed to create session. Please try again. \n${error}`);
                }
            }
        } else {
            toast.error("Selected target is not a sensor");
        }
    };

    useEffect(() => {
        if (
            checkValidity(sessionForm.get()) &&
            valid &&
            validPacket &&
            validNumber &&
            validVNI &&
            hasChanges
        ) {
            setButtonState(true);
        } else {
            setButtonState(false);
        }
    }, [
        checkValidity(sessionForm.get()),
        valid,
        validNumber,
        validPacket,
        validVNI,
        hasChanges,
        buttonState,
        sessiondata,
    ]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper>
                    <Box p={5}>
                        <Grid container>
                            <Grid item xs={12} container>
                                <Box>
                                    <Typography variant="h6">
                                        {readonly
                                            ? "View Traffic Mirror Session"
                                            : isUpdate
                                                ? "Modify Traffic Mirror Session"
                                                : "Create Traffic Mirror Session"}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} container spacing={2} marginTop={2}>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="normal">
                                        <Validator
                                            disabled={readonly}
                                            errorText="Session description cannot be empty"
                                            fullWidth
                                            label="Session Description"
                                            name="Description"
                                            value={sessiondata.Description || ""}
                                            onChange={(e, validID, valid) => {
                                                handleSessionChange(e, validID, valid);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} container spacing={2}>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth margin="normal">
                                            <Autocomplete
                                                disabled={readonly || isUpdate}
                                                value={sessiondata.NetworkInterfaceId}
                                                onChange={(event, newValue) =>
                                                    handleAutocompletechange(
                                                        event,
                                                        newValue
                                                            ? typeof newValue === "object"
                                                                ? newValue.value
                                                                : newValue
                                                            : null,
                                                        "NetworkInterfaceId"
                                                    )
                                                }
                                                options={sourceList}
                                                getOptionLabel={(option) =>
                                                    typeof option === "object"
                                                        ? `${option.label} - \n${option.value}`
                                                        : option
                                                }
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Mirror Source" />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth margin="normal">
                                            <Autocomplete
                                                disabled={readonly}
                                                value={sessiondata.TrafficMirrorTargetId}
                                                onChange={(event, newValue) =>
                                                    handleAutocompletechange(
                                                        event,
                                                        newValue
                                                            ? typeof newValue === "object"
                                                                ? newValue.value
                                                                : newValue
                                                            : null,
                                                        "TrafficMirrorTargetId"
                                                    )
                                                }
                                                options={targetList}
                                                getOptionLabel={(option) =>
                                                    typeof option === "object"
                                                        ? `${option.label} - \n${option.value}`
                                                        : option
                                                }
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Mirror Target" />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth margin="normal">
                                            <Autocomplete
                                                disabled={readonly}
                                                value={sessiondata.TrafficMirrorFilterId}
                                                onChange={(event, newValue) =>
                                                    handleAutocompletechange(
                                                        event,
                                                        newValue
                                                            ? typeof newValue === "object"
                                                                ? newValue.value
                                                                : newValue
                                                            : null,
                                                        "TrafficMirrorFilterId"
                                                    )
                                                }
                                                options={filterList}
                                                getOptionLabel={(option) =>
                                                    typeof option === "object"
                                                        ? `${option.label} - \n${option.value}`
                                                        : option
                                                }
                                                renderInput={(params) => (
                                                    <TextField {...params} label=" Mirror Filter" />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth margin="normal">
                                            <Validator
                                                disabled={readonly}
                                                valueType="range"
                                                errorText="Session Number must be within 1 and 32766"
                                                fullWidth
                                                label="Session Number"
                                                type="number"
                                                inputProps={{
                                                    min: 1,
                                                    max: 32766,
                                                }}
                                                name="SessionNumber"
                                                value={
                                                    sessiondata.SessionNumber == null
                                                        ? ""
                                                        : sessiondata.SessionNumber
                                                }
                                                onChange={handleSessionNumber}
                                            />
                                            <FormHelperText>Number between 1 and 32766</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth margin="normal">
                                            <Validator
                                                disabled={readonly}
                                                valueType="range"
                                                fullWidth
                                                allowEmpty
                                                label="Packet Length - Optional"
                                                type="number"
                                                inputProps={{
                                                    min: 1,
                                                    max: 1540,
                                                }}
                                                name="PacketLength"
                                                value={
                                                    sessiondata.PacketLength == null
                                                        ? ""
                                                        : sessiondata.PacketLength
                                                }
                                                onChange={handlePacketlength}
                                            />
                                            {!validPacket && (
                                                <FormHelperText error>
                                                    Packet length must be within 1 and 1540
                                                </FormHelperText>
                                            )}
                                            <FormHelperText>
                                                If not specified, entire packet will be mirrored
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth margin="normal">
                                            <Validator
                                                disabled={readonly}
                                                valueType="range"
                                                fullWidth
                                                label="VNI - Optional"
                                                allowEmpty
                                                type="number"
                                                inputProps={{
                                                    min: 1,
                                                    max: 16777215,
                                                }}
                                                name="VirtualNetworkId"
                                                value={
                                                    sessiondata.VirtualNetworkId == null
                                                        ? ""
                                                        : sessiondata.VirtualNetworkId
                                                }
                                                onChange={handleVNI}
                                            />
                                            {!validVNI && (
                                                <FormHelperText error>
                                                    VNI must be within 1 and 16777215
                                                </FormHelperText>
                                            )}
                                            <FormHelperText>Number between 1 and 16777215</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} mt={2} container justifyContent="flex-end">
                                <Box mr={2}>
                                    <Button
                                        onClick={handleClose}
                                        variant="contained"
                                        color="secondary"
                                        className={classes.button}
                                    >
                                        {readonly ? "Back" : "Cancel"}
                                    </Button>
                                    {!readonly && (
                                        <Button
                                            onClick={handleSubmit}
                                            variant="contained"
                                            color="primary"
                                            className={classes.button}
                                            disabled={!buttonState}
                                        >
                                            {isUpdate ? "Update" : "Save"}
                                        </Button>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CreateSession;
